import React from 'react';
import './Skeleton.css'; 

const Skeleton = ({ variant = 'rectangular', width = '100%', height = '20px', animation = 'wave', borderRadius = '4px' }) => {

  const styles = {
    width,
    height,
    borderRadius: variant === 'circular' ? '50%' : borderRadius, 
  };

  return (
    <div 
      className={`skeleton ${animation}`} 
      style={styles} 
    />
  );
};

export default Skeleton;
